import React from 'react';
import styled from 'styled-components';

const IDCardBody = styled.div.attrs(() => ({}))<{
  backgroundGradient: string;
}>`
  height: 120px;
  border-radius: 10px;
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 210px;
  background: ${(props) => props.backgroundGradient};
`;

const IDCartNumberWrapper = styled.div`
  padding: 4px 8px;
  background: #2e2e2e;
  border-radius: 4px;
`;

const IDNumberText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: no-wrap;
`;

const colors = [
  'linear-gradient(59.66deg, #DBCF9E 0%, #CFE5D8 100%)',
  'linear-gradient(59.66deg, #E6B6C6 0%, #E8CFDC 100%)',
  'linear-gradient(59.66deg, #4F2E39 0%, #773B50 100%)',
];

const IDCard = (props: {
  number: string;
  expiry: string;
  type: string;
  index: number;
}): JSX.Element => {
  return (
    <IDCardBody backgroundGradient={colors[props.index % colors.length]}>
      <IDCartNumberWrapper>
        <IDNumberText className="text-16">
          <b>{props.number}</b>
        </IDNumberText>
      </IDCartNumberWrapper>
      <div>
        <div className={'text-12' + (props.index % colors.length === 2 ? '' : ' text-dark')}>
          <b>{props.expiry}</b>
        </div>
        <div className={'text-12' + (props.index % colors.length === 2 ? '' : ' text-dark')}>
          {props.type}
        </div>
      </div>
    </IDCardBody>
  );
};
export default IDCard;
